import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  notice: {
    borderRadius: theme.sizes.innerCorners,
    padding: theme.spacing(3, 4),
    fontSize: 14,
    color: theme.colorPalette.green_100
  },
  errors: {
    border: `1px solid ${theme.colorPalette.red_100}`,
    backgroundColor: theme.colorPalette.red_100_10
  },
  warning: {
    border: `1px solid ${theme.colorPalette.orange_50_op_50}`,
    backgroundColor: theme.colorPalette.orange_50_op_08
  },
  title: {
    margin: 0,
    fontWeight: 600
  },
  list: {
    margin: theme.spacing(2, 0, 0),
    paddingLeft: theme.spacing(5)
  },
  text: {
    margin: theme.spacing(1, 0, 0)
  }
});

export default makeStyles(styles);
